// Yayın ve site sponsorları.
//
//   yönetim   /api/admin/sponsors          (Sponsorlar ekranı)
//   reji      /api/maclar/:id/broadcast-state  (sponsoru ekrana ver, altyazı, röportaj)
//   site      /public/sponsors              (oturumsuz; sağ/sol bant, banner)
import api, { apiGet, invalidateApiCache } from "../api/api";
import { uploadImage } from "./mediaUpload";

const BASE = "/api/admin/sponsors";

// Yayın grafikleri 1920 × 1080; varsayılan 1600 px küçültme bunları bozardı.
const SPONSOR_IMAGE_PREPARE = { maxEdge: 3840, budget: 6 * 1024 * 1024 };

const sponsorsApi = {
  catalog: () => api.get(`${BASE}/catalog`, { cacheTtl: 0 }).then((res) => res.data),
  list: (params = {}) => api.get(BASE, { params, cacheTtl: 0 }).then((res) => res.data?.sponsors || []),
  get: (id) => api.get(`${BASE}/${id}`, { cacheTtl: 0 }).then((res) => res.data?.sponsor),
  create: async (payload) => {
    const res = await api.post(BASE, payload);
    invalidateApiCache("/public/sponsors");
    return res.data?.sponsor;
  },
  update: async (id, payload) => {
    const res = await api.patch(`${BASE}/${id}`, payload);
    invalidateApiCache("/public/sponsors");
    return res.data?.sponsor;
  },
  remove: async (id) => {
    const res = await api.delete(`${BASE}/${id}`);
    invalidateApiCache("/public/sponsors");
    return res.data;
  },
  /** Görseli yükler ve adresini döndürür; sponsor kaydedilince kalıcı olur. */
  uploadImage: async (file, { onProgress } = {}) => {
    const { url } = await uploadImage({
      path: `${BASE}/upload`,
      field: "image",
      file,
      method: "post",
      onProgress,
      prepare: SPONSOR_IMAGE_PREPARE,
    });
    return url;
  },
};

/* ------------------------------ reji paneli ------------------------------ */

const stateBase = (matchId) => `/api/maclar/${encodeURIComponent(matchId)}/broadcast-state`;

export const fetchBroadcastState = (matchId) =>
  api.get(stateBase(matchId), { cacheTtl: 0 }).then((res) => res.data);

/** Kısmi güncelleme: { onAir }, { corner }, { subtitle }, { interview }, { led }. */
export const saveBroadcastState = (matchId, patch) =>
  api.put(stateBase(matchId), patch).then((res) => res.data);

/** Altyazı için yapay zekâ manşetleri üretir; kaydetmez. → { headlines, source } */
export const generateAiHeadlines = (matchId, { count = 8, tone = "" } = {}) =>
  api.post(`${stateBase(matchId)}/ai-headlines`, { count, tone }, { timeout: 60000 }).then((res) => res.data);

/* --------------------------------- site --------------------------------- */

// apiGet: 5 dk önbellek + eşzamanlı istekleri birleştirme. Sağ/sol bant, alt
// bilgi ve banner aynı listeyi istediği için her sayfa açılışında tek istek gider.
export const fetchSiteSponsors = (cityId) =>
  apiGet("/public/sponsors", { params: cityId ? { cityId } : {}, cacheTtl: 5 * 60 * 1000 })
    .then((res) => (Array.isArray(res.data?.sponsors) ? res.data.sponsors : []));

export default sponsorsApi;
